import { Component, OnInit, Inject,OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { StaffService } from '../staff.service';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef,  MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { StaffGroup,StaffGroupForCreationResponse, getStaffGroup, deleteStaffGroup} from '../staff';
import { ApiService } from '../../../api.service';
import { getGroupNotification } from '../../../api';
import { AddStaffGroupComponent } from './add-staff-group/add-staff-group.component';
import { EditStaffGroupComponent } from './edit-staff-group/edit-staff-group.component';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage, getFeatureNeedtoShow, getAddEditDeleteColumn, AuthFailedMessage } from '../../../app-general';
import {Router} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { enumUIFeatureView, enumUIAction, enumUIView } from '../../../app-settings';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';

@Component({
  selector: 'app-show-staff-group',
  templateUrl: './show-staff-group.component.html',
  providers: [ StaffService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./show-staff-group.component.scss']
})
export class ShowStaffGroupComponent implements OnInit,OnDestroy {

  StaffGroup: StaffGroup[];
  dataSource;
  dataSourcecount = 1;
  displayedColumns: string[] = ['GroupName', 'Description', 'Staffs', 'Edit', 'Delete'];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  SiteId = "1";
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<ShowStaffGroupComponent>, @Inject(MAT_DIALOG_DATA) public data: string,
  @Inject(RollbarService) private rollbar: Rollbar,
  private staffService: StaffService,private apiService: ApiService,public dialog: MatDialog) {
    mediaObserver.media$.subscribe((change: MediaChange) => {
      if (getFeatureNeedtoShow(enumUIFeatureView.Staff_Group, enumUIAction.Staff_Group_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }
    if (change.mqAlias == this.xscurrentScreenWidth) {
        this.setupTableforXtrasmallerwidth();
    }
    else if (change.mqAlias == this.smcurrentScreenWidth) {
        this.setupTableforsmallerwidth();
    }
      else
    {
      this.setupFullTable();
    }
      });
   }

  ngOnInit() {
    if (getFeatureNeedtoShow(enumUIFeatureView.Staff_Group, enumUIAction.Staff_Group_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    this.getStaffGroup();
  }

setupTableforXtrasmallerwidth() {
    this.displayedColumns = ['GroupName','Count', 'Edit', 'Delete']; 
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete); 
};

setupTableforsmallerwidth() {
    this.displayedColumns = ['GroupName','Staffs', 'Count', 'Edit', 'Delete'];
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
};

setupFullTable() {
    this.displayedColumns = ['GroupName', 'Description', 'Staffs', 'Count', 'Edit', 'Delete'];
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
};

public onCloseCancel = () => {
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
}

getStaffGroup(): void{
  try
  {
    var staffgroupitem : getStaffGroup = 
    {      
      authKey: localStorage.getItem("Authkey")
    };
    this.staffService.getStaffGroup(staffgroupitem).pipe(takeUntil(this._onDestroy))
    .subscribe((StaffGroup : any[])=>{
      this.StaffGroup = StaffGroup["apiReturn"];     
      this.dataSource = new MatTableDataSource(this.StaffGroup);          
      this.dataSource.data = this.StaffGroup;                   
      this.dataSourcecount= this.dataSource.data.length; 
    });
  }
  catch (err) {
    throw new Error('show-staff-group.component.ts' + ' - getStaffGroup() - ' + err.message);
  }
}

 /*********Add Staff group dialogwindow*******/
 AddStaffGroup() { 
  if(!SessionCheck(this.router))
  {
    this.thisDialogRef.close('Cancel');
      return;
  }
  let dialogRef = this.dialog.open(AddStaffGroupComponent, {
    disableClose: true,
    width: '550px',
    height:'300px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
  });
  dialogRef.afterClosed().subscribe(result => {    
    if(result == "Confirm")   
        this.getStaffGroup();
    else
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
    }
  })
}

/////////////////*********Edit Staff group******/
editStaffGroupdata(Groupid: number, Groupname: string,description: string)
{  
  if(!SessionCheck(this.router))
  {
    this.thisDialogRef.close('Cancel');
      return;
  }  
    let StaffGroupDetail = { GroupId: Groupid, Groupname: Groupname, Description: description};
    let dialogRef = this.dialog.open(EditStaffGroupComponent, {
      disableClose: true,
      width: '550px',
      height:'300px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: StaffGroupDetail      
    });    
    dialogRef.afterClosed().subscribe(result => {      
      if(result == "Confirm")   
           this.getStaffGroup(); 
      else
      {
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }
      }
    })
}

////////////////////Delete Resident Group////////////

deleteStaffGroupdata(Groupid: number)
{  
  if(!SessionCheck(this.router))
  {
    this.thisDialogRef.close('Cancel');
      return;
  } 
  this.getGroupNotificationInfo(Groupid);     
}
getGroupNotificationInfo(Groupid)
{
  try
  {    
    var ConfirmMessageData = {
      ConfirmMessage: "Are you sure you want to delete this Group?"                  
    }     
    let dialogRef = this.dialog.open(ConfirmMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ConfirmMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "Yes")
      {                    
        
        var DeleteStaffgroup : getGroupNotification = {siteId:this.SiteId, authKey: localStorage.getItem("Authkey"),groupId:parseInt(Groupid),groupType:1}        
        this.apiService.getGroupNotificationInfo(DeleteStaffgroup).pipe(takeUntil(this._onDestroy))
          .subscribe((apigroupresponse : any[])=>{              
            if(apigroupresponse.toString() == "Success")
            {
              this.deleteStaffGroup(Groupid)              
            }
            else
            {
              generateAlertMessage(this.dialog, "This '"+apigroupresponse[0].GroupName+"' is in escalation level, so please remove this group from escalation and try again.")
            }
          })                         
      }
      else
      {
          dialogRef.close('Cancel');
          return;
      }
    });
  }
  catch(err)
  {
      throw new Error('delete-staff-group.ts' + ' - getGroupNotificationInfo() - ' + err.message);
  }   
}

deleteStaffGroup(Groupid)
{
  var DeleteStaffgroup : deleteStaffGroup = 
  {    
    authKey: localStorage.getItem("Authkey"),
    groupId:Groupid
  }
  this.staffService.deleteStaffGroup(DeleteStaffgroup).pipe(takeUntil(this._onDestroy))
  .subscribe((apiresponse : StaffGroupForCreationResponse[])=>{            
    if(apiresponse["apiReturn"] == "Success")
    { 
      generateAlertMessage(this.dialog, 'Staff group deleted successfully.')	              
    }
    else if(apiresponse["apiReturn"] == "Fail")
    {
      generateAlertMessage(this.dialog, 'Staff group deleted failed.')              
    }
    else if (apiresponse["apiReturn"] == "Invalid Auth Key") {
      this.thisDialogRef.close("close");
      AuthFailedMessage(this.dialog, this.router);
      return;
    }
    else
    {
      generateAlertMessage(this.dialog, apiresponse.toString())              
    }
    this.getStaffGroup(); 
  }); 
}

ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
